import { useContext } from 'react';

import CountryConfigContext from '.';

export default function useConfiguration() {
  return useContext(CountryConfigContext);
}
